import { Paper, Theme, styled } from '@material-ui/core';

const Card = styled(Paper)<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  transition: 'all 0.2s ease-in-out',
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  '&.rounded': {
    borderRadius: theme.config.borderRadiusCluster,
  },
}));

export default Card;
